// ./src/components/features/Themes/ThemeFormModal/ThemeSectionEditor.tsx
import React from "react";
import { Stack, Text, Box } from "@mantine/core";
import { ThemeGroupEditor, ThemeGroupConfig } from "./ThemeGroupEditor";

export interface ThemeSectionConfig {
  sectionName: string;
  sectionKey: string;
  description?: string;
  groups: ThemeGroupConfig[];
}

export interface ThemeSectionEditorProps {
  /** Section configuration from themeEditorUiConfig */
  sectionConfig: ThemeSectionConfig;

  /** Complete theme config object */
  themeConfigData: Record<string, any>;

  /** Callback when any element value changes */
  onConfigChange: (path: string, value: string | null) => void;
}

export const ThemeSectionEditor: React.FC<ThemeSectionEditorProps> = ({
  sectionConfig,
  themeConfigData,
  onConfigChange,
}) => {
  const { sectionName, description, groups } = sectionConfig;

  // Don't render if no groups
  if (!groups || groups.length === 0) {
    return (
      <Box p="md">
        <Text size="sm" c="dimmed">
          No configuration available for this section.
        </Text>
      </Box>
    );
  }

  return (
    <Stack gap="xl">
      {/* Section header */}
      <Stack gap="xs">
        <Text size="lg" fw={600}>
          {sectionName}
        </Text>
        {description && (
          <Text size="sm" c="dimmed">
            {description}
          </Text>
        )}
      </Stack>

      {/* Render all groups */}
      <Stack gap="xl">
        {groups.map((groupConfig, index) => (
          <ThemeGroupEditor
            key={`${groupConfig.groupName}-${index}`}
            groupConfig={groupConfig}
            themeConfigData={themeConfigData}
            onConfigChange={onConfigChange}
            isFirst={index === 0}
          />
        ))}
      </Stack>
    </Stack>
  );
};
